/*
 * @Author: your name
 * @Date: 2020-12-14 20:01:45
 * @LastEditTime: 2020-12-23 15:34:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fe-yanjiusheng-h5/src/components/ClassCard/index.js
 */
import React from 'react';
import Link from '../Link';
import './index.scss';

const ClassCard = ({ className = "", data, mod = '', isChackLogin = false }) => {

  const Item = (item, index) => {

    return (
      <Link
        className="com-class-card-item"
        key={index}
        check_login = { isChackLogin }
        href={`./course.html?product_id=${item.product_id}`}
      >
        <div className={`com-class-card-item-avatar`}>
          <img
            src={item.img_url}
            alt={item.product_name}
          />
        </div>

        <div className={`com-class-card-item-content`}>
          <div className={`com-class-card-item-title`}>
            {item.product_name}
          </div>
          <div className={`com-class-card-item-info`}>
            <div className={`com-class-card-item-date`}>
              { item.buyer_num ? `${item.buyer_num_txt}人学习` : '' }
            </div>
            <div className={`com-class-card-item-action`}>
              {
                item.orgi_price && item.orgi_price !== '0' ?
                  <span className={`com-class-card-item-origin-price`}>
                    ¥{item.orgi_price}
                  </span> : null
              }
              {
                item.sale_price ?
                  <span className={`com-class-card-item-price`}>
                    {item.sale_price * 1 > 0 ? ("¥" + item.sale_price) : "免费"}
                  </span> : null
              }
            </div>
          </div>
        </div>
      </Link>
    )
  }

  return (
    <div className={`com-class-card ${className}`}>
      {
        mod && <div className="com-class-card-title">
          {mod.name}
          {
            mod.link_page_id ?
              <Link className="com-class-card-more" href={`./course.html?page_id=${mod.link_page_id}`}>
                查看更多
              </Link>
              : null
          }
        </div>
      }
      <div className="com-class-card-list">
        {
          data.map((item, index) => (Item(item, index)))
        }
      </div>
    </div>
  )

}

export default ClassCard;

